import { useMemo } from "react";
import { qrSvgPath } from "./qr";

export interface QrCodeProps {
  /** Text to encode — the班级 registration link or the invite code. */
  value: string;
  /** Rendered edge length in px. @default 160 */
  size?: number;
  /** Accessible name; the code itself is also printed next to it. */
  label?: string;
  className?: string;
}

/**
 * Inline SVG QR code (docs/UX.md §3.1). Crisp at any size, prints well and
 * needs no network request. Falls back to a readable message if the value is
 * too long for the small-version encoder.
 */
export function QrCode({ value, size = 160, label, className }: QrCodeProps) {
  const qr = useMemo(() => {
    try {
      return qrSvgPath(value);
    } catch {
      return null;
    }
  }, [value]);

  if (!qr) {
    return (
      <p className="gz-caption" role="status">
        这段内容太长，没法生成二维码，请直接复制链接。
      </p>
    );
  }

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${qr.size} ${qr.size}`}
      role="img"
      aria-label={label ?? "二维码"}
      shapeRendering="crispEdges"
    >
      {/* Literal black on white on purpose: a QR has to stay scannable in the
          dark theme and on paper, so it does not follow the surface tokens. */}
      <rect width={qr.size} height={qr.size} fill="#ffffff" />
      <path d={qr.path} fill="#000000" />
    </svg>
  );
}
